import axiosClient, { tokenStore } from './axiosClient';

/** Auth + account endpoints. All methods return the unwrapped `data` payload. */
const authService = {
  registerClient: (payload) =>
    axiosClient.post('/auth/register/client', payload).then(persist),

  registerTechnician: (payload) =>
    axiosClient.post('/auth/register/technician', payload).then(persist),

  login: (email, password) =>
    axiosClient.post('/auth/login', { email, password }).then(persist),

  refresh: (refreshToken) =>
    axiosClient.post('/auth/refresh', { refreshToken }).then(persist),

  me: () => axiosClient.get('/auth/me'),

  changePassword: (currentPassword, newPassword) =>
    axiosClient.post('/auth/change-password', { currentPassword, newPassword }),

  logout: () => {
    tokenStore.clear();
  },

  currentUser: () => tokenStore.getUser(),
  isAuthenticated: () => Boolean(tokenStore.getAccess()),
};

function persist(auth) {
  tokenStore.set({
    token: auth.token,
    refreshToken: auth.refreshToken,
    user: auth.user,
  });
  return auth;
}

export default authService;
